import { cx } from '@emotion/css';
import { Button, COLORS } from '@sortlist-frontend/design-system/legacy';
import { FC, Fragment, ReactNode } from 'react';

import { SectionShape } from '_components/common/SectionShape';
import { usePublicAppContext } from '_core/context/public-app-context';
import * as S from '_features/Pricing/components/Header/styles';

type Props = {
  className?: string;
  title: string | ReactNode;
  subtitle?: string;
  ctaLabel?: string;
};

export const Header: FC<Props> = (props) => {
  const { className, title, subtitle, ctaLabel } = props;
  const { getUrl } = usePublicAppContext();
  const agencyClaimLandingUrl = getUrl('agency.claim.landing');

  return (
    <Fragment>
      <header data-testid="providers-header" className={cx(className)}>
        <div className="container-lg text-center pt-14 pb-16 sm:pb-8 lg:pb-16 lg:pt-32">
          <S.MainTitle className="text-neutral-100 bold serif">{title}</S.MainTitle>
          {subtitle && <h6 className="text-secondary-500 mt-4">{subtitle}</h6>}
          {ctaLabel && (
            <Button
              label={ctaLabel}
              size="lg"
              buttonVariant="raised"
              buttonStyle="secondary"
              className="mt-8 border-none"
              onClick={() => (window.location.href = agencyClaimLandingUrl)}
              id="open-agency-claim-btn"
            />
          )}
        </div>
      </header>
      <SectionShape color={COLORS.SECONDARY_900} height={148} className="hide-xs bg-secondary-50" />
    </Fragment>
  );
};
